import { bodyBgColor } from './BodyBgStore.js';

export const updateBodyBgColor = (value) => bodyBgColor.update(oldValue => value);
